module.exports = __webpack_public_path__ + "img/balcklist-warring-with-wechat.462e0f1f.png";